<template>
  <div>
    <div v-if="!isMobile" class="about-top-cell">
      <div class="cell-item" v-for="(item, index) in cptList" :key="index">
        <span class="label">
          {{ item.label }}
        </span>
        <div class="content">{{ item.content }}</div>
      </div>
    </div>
    <el-carousel
      v-if="isMobile"
      indicator-position="outside"
      class="isMobile-cell"
      :interval="5000"
    >
      <el-carousel-item
        class="cell-item"
        v-for="(item, index) in cptList"
        :key="index"
      >
        <span class="label">
          {{ item.label }}
        </span>
        <div class="content">{{ item.content }}</div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { list } from './config'
export default {
  name: 'about-top-cell',
  data() {
    return {
      isMobile: false,
    }
  },
  created() {
    this.isMobile = this.$store.state.app.device
  },
  computed: {
    cptList() {
      return list
    },
  },
}
</script>
<style lang="scss" scoped>
.about-top-cell {
  display: flex;
  width: 1160px;
  margin: auto;
  .cell-item {
    padding: 30px 50px;
    line-height: 22px;
    margin-bottom: 12px;
    display: inline;
    background-color: rgba($color: #0f1921, $alpha: 0.5);
    width: 360px;
    margin: 60px 15px 0 60px;
    cursor: pointer;
    transition: all 0.3s linear;
    position: relative;
    top: 0px;
    .label {
      font-size: 16px;
      position: relative;
      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 6px;
        height: 17px;
        transform: skew(-10deg);
        background-color: #29bdb9;
        transition: all 0.3s linear;
      }
      &::before {
        top: -10px;
        left: -14px;
        opacity: 0;
        transition: all 0.3s linear;
      }
      &::after {
        top: 10px;
        right: -14px;
        opacity: 0;
        transition: all 0.3s linear;
      }
    }
    .content {
      font-size: 12px;
      padding: 20px 0 0;
    }
    &:hover {
      top: -16px;
      .label {
        &::before {
          top: 3px;
          left: -14px;
          opacity: 1;
        }
        &::after {
          top: 3px;
          right: -14px;
          opacity: 1;
        }
      }
    }
  }
}
</style>
<style lang='scss'>
.isMobile-cell {
  padding: 20px 20px 0 20px;
  margin: 20px;
  background-color: rgba($color: #0f1921, $alpha: 0.5);
  .label {
    font-size: 16px;
  }
  .contnet {
    padding-top: 20px;
  }
  .el-carousel__container {
    height: 90px;
  }
  .el-carousel__indicators--horizontal {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/about/about-top-cell/index.vue